// src/modules/app-views/_apps/appmulti/leads/pages/Init/actions/actionButton.js
// *******************************************************************************
// ACTION BUTTON — Leads are populated externally; no new-document button in UI.
// Returns null (no primary action button).
// *******************************************************************************
const leadsInitActionButton = () => null;

export default leadsInitActionButton;
